// package: usermanager
// file: user-manager.proto

var user_manager_pb = require("./user-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var UserManager = (function () {
  function UserManager() {}
  UserManager.serviceName = "usermanager.UserManager";
  return UserManager;
}());

UserManager.AddUser = {
  methodName: "AddUser",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.AddUserReq,
  responseType: user_manager_pb.AddUserReply
};

UserManager.EditUser = {
  methodName: "EditUser",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.EditUserReq,
  responseType: user_manager_pb.EditUserReply
};

UserManager.DeleteUser = {
  methodName: "DeleteUser",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.DeleteUserReq,
  responseType: user_manager_pb.DeleteUserReply
};

UserManager.UpdateEmail = {
  methodName: "UpdateEmail",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.UpdateEmailReq,
  responseType: user_manager_pb.UpdateEmailReply
};

UserManager.HasQueuedEditEmail = {
  methodName: "HasQueuedEditEmail",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.HasQueuedEditEmailReq,
  responseType: user_manager_pb.HasQueuedEditEmailReply
};

UserManager.GetUserInfo = {
  methodName: "GetUserInfo",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.GetUserInfoReq,
  responseType: user_manager_pb.GetUserInfoReply
};

UserManager.UpdatePassword = {
  methodName: "UpdatePassword",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.UpdatePasswordReq,
  responseType: user_manager_pb.UpdatePasswordReply
};

UserManager.GenerateNoltToken = {
  methodName: "GenerateNoltToken",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.GenerateNoltTokenReq,
  responseType: user_manager_pb.GenerateNoltTokenReply
};

UserManager.SubscribeToBeta = {
  methodName: "SubscribeToBeta",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.SubscribeToBetaReq,
  responseType: user_manager_pb.SubscribeToBetaReply
};

UserManager.MarkTourCompleted = {
  methodName: "MarkTourCompleted",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.MarkTourCompletedReq,
  responseType: user_manager_pb.MarkTourCompletedReply
};

UserManager.GetMyEarlyAccess = {
  methodName: "GetMyEarlyAccess",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.GetMyEarlyAccessReq,
  responseType: user_manager_pb.GetMyEarlyAccessReply
};

UserManager.GetMyAnnouncementState = {
  methodName: "GetMyAnnouncementState",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.GetMyAnnouncementStateReq,
  responseType: user_manager_pb.GetMyAnnouncementStateReply
};

UserManager.MarkAnnouncements = {
  methodName: "MarkAnnouncements",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.MarkAnnouncementsReq,
  responseType: user_manager_pb.MarkAnnouncementsReply
};

UserManager.ListConnectedApps = {
  methodName: "ListConnectedApps",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.ListConnectedAppsReq,
  responseType: user_manager_pb.ListConnectedAppsReply
};

UserManager.RevokeConnectedApp = {
  methodName: "RevokeConnectedApp",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.RevokeConnectedAppReq,
  responseType: user_manager_pb.RevokeConnectedAppReply
};

UserManager.AdminGetUserInfo = {
  methodName: "AdminGetUserInfo",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.AdminGetUserInfoReq,
  responseType: user_manager_pb.AdminGetUserInfoReply
};

UserManager.AdminListUsers = {
  methodName: "AdminListUsers",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.AdminListUsersReq,
  responseType: user_manager_pb.AdminListUsersReply
};

UserManager.AdminOverview = {
  methodName: "AdminOverview",
  service: UserManager,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.AdminOverviewReq,
  responseType: user_manager_pb.AdminOverviewReply
};

exports.UserManager = UserManager;

function UserManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

UserManagerClient.prototype.addUser = function addUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.AddUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.editUser = function editUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.EditUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.deleteUser = function deleteUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.DeleteUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.updateEmail = function updateEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.UpdateEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.hasQueuedEditEmail = function hasQueuedEditEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.HasQueuedEditEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.getUserInfo = function getUserInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.GetUserInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.updatePassword = function updatePassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.UpdatePassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.generateNoltToken = function generateNoltToken(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.GenerateNoltToken, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.subscribeToBeta = function subscribeToBeta(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.SubscribeToBeta, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.markTourCompleted = function markTourCompleted(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.MarkTourCompleted, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.getMyEarlyAccess = function getMyEarlyAccess(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.GetMyEarlyAccess, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.getMyAnnouncementState = function getMyAnnouncementState(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.GetMyAnnouncementState, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.markAnnouncements = function markAnnouncements(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.MarkAnnouncements, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.listConnectedApps = function listConnectedApps(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.ListConnectedApps, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.revokeConnectedApp = function revokeConnectedApp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.RevokeConnectedApp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.adminGetUserInfo = function adminGetUserInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.AdminGetUserInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.adminListUsers = function adminListUsers(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.AdminListUsers, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

UserManagerClient.prototype.adminOverview = function adminOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(UserManager.AdminOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.UserManagerClient = UserManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "usermanager.Internal";
  return Internal;
}());

Internal.IntEnableUser = {
  methodName: "IntEnableUser",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.IntEnableUserReq,
  responseType: user_manager_pb.IntEnableUserReply
};

Internal.IntUpdateOverdueRole = {
  methodName: "IntUpdateOverdueRole",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.IntUpdateOverdueRoleReq,
  responseType: user_manager_pb.IntUpdateOverdueRoleReply
};

Internal.IntGetUserInfo = {
  methodName: "IntGetUserInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: user_manager_pb.IntGetUserInfoReq,
  responseType: user_manager_pb.IntGetUserInfoReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intEnableUser = function intEnableUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntEnableUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateOverdueRole = function intUpdateOverdueRole(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateOverdueRole, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUserInfo = function intGetUserInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUserInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

